<template>
    <section class="card card-template">
        <header class="header" :class="borderClass">
            <slot name="header"></slot>
        </header>
        <div class="content">
            <slot name="content"></slot>
        </div>
    </section>
</template>

<style src="./CardTemplate.scss"></style>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        borderClass: {
            type: String,
            default: ""
        }
    }
});
</script>
